import './Sidebar.css';
import { useSelector, useDispatch } from "react-redux";
import { closeSidebar } from "../redux/sidebarSlice";
const Sidebar = () => {
    const status = useSelector((state) => state.sidebar.status)
    const dispatch = useDispatch()
    const width = status ? '250px' : '0px';
    return (
        <div id="mySidebar" className="sidebar" style={{width: width}}>
            <a href="#" className="closebtn" onClick= {() => dispatch(closeSidebar())}>&times;</a>
            <a href="#">About</a>
            <a href="#">Services</a>
            <a href="#">Clients</a>
            <a href="#">Contact</a>
        </div>
    );
}

export default Sidebar;